export enum RiskGroupShortCodeEnum {
  LowExchange = 0,
  Low = 1,
  Medium = 2,
  High = 3,
  Severe = 4,
  NotAssessed = 5,
}
